// notesIndex — leaf bridge between the attorney notepad and the document
// inventory. The notepad clips live in NotepadContext (app-level); the
// inventory column registry + filter axes are plain modules whose render/
// predicate functions can't use hooks. InventoryTab builds a per-document
// count map from the loaded clips and publishes it here; the notes column and
// the "Notes" filter axis read it.
//
// No imports → safe leaf (see the circular-import lesson for context files).
// Eventual consistency is fine: clips load on case mount, well before the
// inventory is interacted with, and InventoryTab republishes on every change.

let _index = {}; // { [documentId]: { total: number, mine: number } }

export function setNotesIndex(idx) {
  _index = idx || {};
}

export function docNoteCount(documentId) {
  return _index[documentId]?.total || 0;
}

export function docMineNoteCount(documentId) {
  return _index[documentId]?.mine || 0;
}

/** Build a {docId: {total, mine}} map from a clip list + current user id. */
export function buildNotesIndex(clips, myUid) {
  const idx = {};
  for (const c of clips || []) {
    if (!c.document_id) continue;
    const e = idx[c.document_id] || (idx[c.document_id] = { total: 0, mine: 0 });
    e.total += 1;
    if (myUid && c.author_id === myUid) e.mine += 1;
  }
  return idx;
}
